import { InputAdornment, TextField } from '@mui/material';
import { Search, X } from 'lucide-react';
import React from 'react';

interface SearchInputProps {
    value: string;
    onChange: (newValue: string) => void;
}

export default function SearchInput({ value, onChange }: SearchInputProps) {
    const showClearIcon = value === '' ? 'none' : 'flex';
    const handleClearClick = (): void => {
        onChange('');
    };

    return (
        <TextField
            fullWidth
            inputProps={{
                'data-testid': 'modelSearch',
            }}
            size="small"
            variant="outlined"
            placeholder="Search model..."
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onChange(event.target.value)
            }
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search size={14} />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment
                        position="end"
                        style={{ display: showClearIcon, cursor: 'pointer' }}
                        onClick={handleClearClick}
                    >
                        <X size={14} />
                    </InputAdornment>
                ),
            }}
        />
    );
}
